import { thunkProgress } from 'redux-progress';
import type { Dispatch, GetState } from 'model/State';
import { SEARCH_FOR_CONTACT_POST, INVOICE_JSON_GET, INVOICE_PDF } from './types';
import { invoiceJson, invoicePdf, searchForContact, singleSearchForContact } from '../../api';

export const fetchSearchForContactPost =
  (
    maxResults: number,
    offset: number,
    orderNumberMask?: number,
    technicalContactCompanyDomainName?: string,
    integerPartOfTotalAmount?: number,
  ) =>
  (dispatch: Dispatch, getState: GetState) => {
    dispatch(
      thunkProgress(
        SEARCH_FOR_CONTACT_POST,
        searchForContact(
          getState(),
          maxResults,
          offset,
          orderNumberMask,
          technicalContactCompanyDomainName,
          integerPartOfTotalAmount,
        ),
      ),
    );
  };

export const fetchSingleSearchForContactPost =
  (orderId) => (dispatch: Dispatch, getState: GetState) => {
    dispatch(thunkProgress(SEARCH_FOR_CONTACT_POST, singleSearchForContact(orderId, getState())));
  };

export const fetchInvoiceJSON = (orderId: string) => (dispatch: Dispatch, getState: GetState) => {
  const hash = getState().location.query?.hash;
  dispatch(thunkProgress(INVOICE_JSON_GET, invoiceJson(orderId, getState(), hash)));
};

export const fetchInvoicePDF = (orderId: string) => (dispatch: Dispatch, getState: GetState) => {
  const hash = getState().location.query?.hash;
  dispatch(thunkProgress(INVOICE_PDF, invoicePdf(orderId, getState(), hash)));
};
